import React from "react";

const GrayCross = () => (
  <svg
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.35788 8.17551C8.47059 8.28823 8.53392 8.44111 8.53392 8.60051C8.53392 8.75992 8.47059 8.9128 8.35788 9.02551C8.24516 9.13823 8.09228 9.20156 7.93288 9.20156C7.77347 9.20156 7.62059 9.13823 7.50788 9.02551L4.33338 5.85001L1.15788 9.02451C1.04516 9.13723 0.892283 9.20055 0.732877 9.20055C0.573471 9.20055 0.420594 9.13723 0.307877 9.02451C0.19516 8.9118 0.131836 8.75892 0.131836 8.59951C0.131836 8.44011 0.19516 8.28723 0.307877 8.17451L3.48338 5.00001L0.308877 1.82451C0.19616 1.7118 0.132836 1.55892 0.132836 1.39951C0.132836 1.24011 0.19616 1.08723 0.308877 0.974514C0.421594 0.861797 0.574471 0.798474 0.733877 0.798474C0.893283 0.798474 1.04616 0.861797 1.15888 0.974514L4.33338 4.15001L7.50888 0.974014C7.62159 0.861297 7.77447 0.797974 7.93388 0.797974C8.09328 0.797974 8.24616 0.861297 8.35888 0.974014C8.47159 1.08673 8.53492 1.23961 8.53492 1.39901C8.53492 1.55842 8.47159 1.7113 8.35888 1.82401L5.18338 5.00001L8.35788 8.17551Z"
      fill="#A4A3A8"
    />
  </svg>
);

export default GrayCross;
